const incidentStatusOptions = [
  { label: "Open", value: "Open" },
  { label: "Resolved", value: "Resolved" }
];

export default incidentStatusOptions;
